import "../index.css";

export const Resume = () => {
	return (
		<div className="res, side_pad">
			<div className="res_header">
				<div className="resume_name">
					<h1>Joseph Tenore</h1>
				</div>
				<div className="resume_contact">
					<p>
						Easton, MA 02375
						<br />
						Phone# 7742733104
						<br />
						Email JosephTenore@gmail.com
						<br />
						www.linkedin.com/in/josephtenore
						<br />
						Personal Website www.JosephTenore.online
						<br />
						Github https://github.com/Jtenore
					</p>
				</div>
			</div>

			<h1 className="top_pad, res_header2">Skills</h1>
			<h2>Computer Languages: Javascript/React, Ruby, HTML, CSS, SQL, Python, Java, BASH, CLI</h2>

			<div className="skill_box">
				<div>
					<ul>
						<li>Worked with Windows/MacOS/Linux</li>
						<li>Software and Hardware Troubleshooting</li>
						<li>I have built my own PC</li>
						<li>Test driven development</li>
					</ul>
				</div>
				<div>
					<ul>
						<li>Pair programming</li>
						<li>Working on a website</li>
						<li>small amounts of AWS</li>
						<li>Customer service certified</li>
					</ul>
				</div>
				<div>
					<ul>
						<li>Blueprint reading</li>
						<li>CNC Lathe Operation</li>
						<li>Forklift certified</li>
						<li>OSHA certified</li>
					</ul>
				</div>
			</div>

			<div>
				<h1>Professional Development</h1>

				<h2 className="underline_center_top">Google IT Support Fundamentals Certification</h2>
				<p className="text_center">
					This certification program was very diverse, contained many different subjects such as scripting simple automation and formating regular expressions. It covered Customer care and being thorough in your questions while keeping your client feeling safe. The course continued to cover things like various computer hardware. Afterwards what was included was many of the various details of computer networking covering everything from an ethernet frame to many of the networking protocols. It also covered many of he different IT toold such as Active directory, mailing servers, and various topics such as DNS and DHCP. They covered roles of a System Adminitrator and covered many areas of making you think how to set up an IT infrastructure and best practices with Stocking devices for employees. Lastly they touched heavily on IT Security from Password best practices to many security protocols and various encryption methods.
				</p>

				<h2 className="underline_center_top">Launch academy</h2>
				<p className="text_center">
					Launch academy was training that included 18 weeks of immersive full
					stack bootcamp that taught a lot of software development skills but
					one of the most important skills I was taught here was how to learn
					heavy topics in short time frames
				</p>

				<h2 className="underline_center_top">
					Mass MEP Manufacturing training
				</h2>
				<p className="text_center">
					Level 2, Machine Operator Skills Training Level 2 Certificate <br />
					Training included: quality inspection, basic CNC mill and lathe
					operation, introduction to programming, and lean manufacturing <br />
					Level 1, Basic Manufacturing Skills Training Level 1 Certificate
					<br />
					Training included: shop math, blueprint reading, metrology and quality
					inspection, reading calipers and micrometers, and 10-hour OSHA General
					Industry card
				</p>
			</div>

			<div>
				<h1 className="top_pad">Past Jobs</h1>

				<h3>OCT 2022</h3>
				<h2 className="res_header2">
					Help Desk / Massasoit Community College, Brockton MA
				</h2>
				<ul>
					<li>Support with basic over the phone troubleshooting</li>
					<li>Experience with Accurate Ticket assigning</li>
					<li>Some hands on hardware support striping hard drives and component swapping</li>
					<li>Occasionally taking on campus calls to offices</li>
				</ul>

				<h3>MAY 2021</h3>
				<h2 className="res_header2">
					CNC Machine Operator / AMI, Middleboro MA
				</h2>
				<ul>
					<li>
						Read programming instructions and product blueprints to meet
						dimensional requirements
					</li>
					<li>Kept parts in tight tolerences to maintain optimal quality</li>
					<li>
						Observed companies strict safety guidlines to avoid serious injury
					</li>
				</ul>

				<h3>Feb 2020</h3>
				<h2 className="res_header2">
					Recycling Specialist / FHI, Fall River MA
				</h2>
				<ul>
					<li>
						Juggled multiple projects and tasks to ensure high quality and
						timely delivery
					</li>
					<li>
						Demonstrated leadership by making improvements to work processes and
						helping train new employees
					</li>
					<li>
						Sorted recycled and recyclable materials into various areas for
						further processing
					</li>
				</ul>

				<h3>DEC 2018</h3>
				<h2 className="res_header2">
					Warehouse Associate / Boston Scientific, Quincy MA
				</h2>
				<ul>
					<li>Kept loading area clean and orderly for safety and efficiency</li>
					<li>
						Utilizing of computers, product handling device - pallet jacks,
						other equipment as required
					</li>
					<li>Making sure supervisor has all paper work as needed</li>
				</ul>

				<h3>Jan 2016</h3>
				<h2 className="res_header2">
					Machine Operator / Cheer Pack, W Bridgewater MA
				</h2>
				<ul>
					<li>
						Produced product according to work-order traveler specifications
					</li>
					<li>
						Responsible for production output of injection molding Machine
					</li>
					<li>
						Kept machines running performing maintenance and unloading of
						product
					</li>
				</ul>

				<h3>JAN 2015</h3>
				<h2 className="res_header2">Game Advisor / Gamestop, Mansfield MA</h2>
				<ul>
					<li>Exceptional Customer service</li>
					<li>
						Learning about company product and selling to their prefferences
					</li>
				</ul>

				<h3>JAN 2011</h3>
				<h2 className="res_header2">Crew Member / Dunkin donuts, Easton MA</h2>
				<ul>
					<li>Exceptional Customer service</li>
					<li>food preperation</li>
					<li>using customer input to output desired results</li>
				</ul>
			</div>
		</div>
	);
};
